<template>
    <el-dialog class="friend-apply" title="申请添加好友" width="400px" :visible.sync="isShow" :before-close="onClose"
        append-to-body>
        <div>
            <el-input type="textarea" v-model="remark" maxlength="255" :autosize="{ minRows: 5 }" show-word-limit>
            </el-input>
            <div class="tip">提示: 对方开启了好友验证,等待对方同意后才能成为好友</div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="onClose()">取 消</el-button>
            <el-button type="primary" @click="onOk()">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name: "friendApply",
    components: {},
    data() {
        return {
            isShow: false,
            remark: "",
            userInfo: {}
        }
    },
    methods: {
        open(userInfo) {
            this.isShow = true;
            this.userInfo = userInfo;
            this.remark = "我是" + this.userStore.userInfo.nickName;
            if (!this.userInfo.isManualApprove) {
                // 对方未开启好友验证,直接发起
                this.sendApplyRequest();
                this.isShow = false;
            }
        },
        onClose() {
            this.isShow = false;
        },
        onOk() {
            this.sendApplyRequest();
		},
		async sendApplyRequest() {
			const accountId = this.userInfo.imAccid || this.userInfo.accountId || this.userInfo.id;
			const addMode = this.userInfo.isManualApprove ? 2 : 1;
			await this.$yunxinIM.addFriend(accountId, this.remark, addMode);
			if (addMode === 1) {
				this.$message.success(`添加成功，'${this.userInfo.nickName}'已成为您的好友`);
				this.friendStore.addFriend({
					id: accountId,
					accountId,
					imAccid: accountId,
					nickName: this.userInfo.nickName,
					showNickName: this.userInfo.nickName,
					headImage: this.userInfo.headImageThumb,
					headImageThumb: this.userInfo.headImageThumb,
					online: this.userInfo.online,
					deleted: false
				});
			} else {
				this.$message.success(`您向'${this.userInfo.nickName}'发起了好友申请`);
				this.friendStore.addRequest({
					id: `${this.mineAccount}_${accountId}_${Date.now()}`,
					sendId: this.mineAccount,
					recvId: accountId,
					sendNickName: this.userStore.userInfo.nickName,
					recvNickName: this.userInfo.nickName,
					sendHeadImage: this.userStore.userInfo.headImageThumb,
					recvHeadImage: this.userInfo.headImageThumb,
					remark: this.remark,
					status: 0,
					timestamp: Date.now()
				});
			}
			this.isShow = false;
		}
	},
	computed: {
		mineAccount() {
			const mine = this.userStore.userInfo;
			return mine.imAccid || mine.accountId || mine.id;
		}
	}

}
</script>


<style lang="scss" scoped>
.friend-apply {
    .tip {
        color: var(--im-text-color-light);
        font-size: var(--im-font-size-small);
        line-height: 35px;
    }
}
</style>
